import React, { useState, useRef, useEffect } from "react";
import { NotifyContainer } from "./style";
import {BoxLoading} from "../loading/components/boxLoading";

export default props => {
  // const [status, setStatus] = useState(false);
  return (
    <NotifyContainer type={props.type} isSeen={props.isSeen}>
      {
        props.loading &&
        <div className='loading'>
          <BoxLoading/>
        </div>
      }
      <div className='date'>
        {props.date}
      </div>
      <div className='message'>
        {props.message}
      </div>
      <div className='footer'>
        <div className='title'>{props.title}</div>
        <div className='action'>
          <div className='button2' onClick={props.button2 && props.button2.action}>{props.button2 && props.button2.text}</div>
          <div className='button1' onClick={props.button1 && props.button1.action}>{props.button1 && props.button1.text}</div>
        </div>
      </div>
    </NotifyContainer>
  );
};